/* eslint-disable react/jsx-props-no-spreading */
// import { getJSON } from '@folklore/fetch';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import SelectField from './Select';

import styles from '../../../styles/fields/country.module.css';

const optionsCache = {};

const countries = [
    {
        name: 'Canada',
        alpha2: 'CA',
    },
];

const propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    defaultValue: PropTypes.string,
    defaultToUserCountry: PropTypes.bool,
};

const CountryField = ({
    value = null,
    onChange = null,
    defaultValue = 'CA',
    defaultToUserCountry = true,
    ...props
}) => {
    const { locale } = useIntl();
    const [options, setOptions] = useState(optionsCache[locale] || null);
    useEffect(() => {
        let canceled = false;
        if (defaultValue) {
            onChange(defaultValue || 'CA');
        } else if (defaultToUserCountry && value === null) {
            // getJSON('https://get.geojs.io/v1/ip/country.json').then((response) => {
            //     const { country } = response || {};
            //     if (!canceled && onChange !== null) {
            //         onChange(country || 'CA');
            //     }
            // });
        }
        return () => {
            canceled = true;
        };
    }, [defaultToUserCountry, defaultValue]);
    useEffect(() => {
        let canceled = false;
        if (options === null) {
            const newOptions = countries.map(({ name, alpha2 }) => ({
                label: name,
                value: alpha2.toUpperCase(),
            }));
            optionsCache[locale] = newOptions;
            if (!canceled) {
                setOptions(newOptions);
            }
        }
        return () => {
            canceled = true;
        };
    }, [options, locale]);
    return (
        <div className={styles.container}>
            <SelectField {...props} value={value} onChange={onChange} options={options || []} />
        </div>
    );
};

CountryField.propTypes = propTypes;

export default CountryField;
